import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import HistoryIcon from "@mui/icons-material/History";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useSelector } from "react-redux";
import TabPanelCmp from "../../components/tabPanel/tabPanelCmp";
import { GetLoanInfoResponse } from "../../models/loan.model";
import BankInfo from "./tabs/BankInfo";
import CancellationReasons from "./tabs/cancelReason";
import ContractInfo from "./tabs/contractInfo";
import FactorInfo from "./tabs/factorInfo";
import FurtherInfo from "./tabs/furtherInfo";
import GuarantorDocuments from "./tabs/guarantorDocuments";
import GuarantorInfo from "./tabs/guarantorInfo";
import IdentityInfo from "./tabs/identityInfo";
import IncomeInfo from "./tabs/incomeInfo";
import InstallmentInfo from "./tabs/installmentInfo";
import PlaceInfo from "./tabs/placeInfo";
import SellerDocument from "./tabs/sellerDocument";
import VehicleDocuments from "./tabs/vehicleDocuments";
import VehicleExpert from "./tabs/vehicleExpert";
import VideoAuthorization from "./tabs/videoAuthorization";
import WorkflowInfo from "./tabs/workflowInfo";
import Installments from "./tabs/installments";
import OtherPayments from "./tabs/otherPayments";
import WalletIcon from "@mui/icons-material/Wallet";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function _TabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabsPanel(props: any) {
  const [value, setValue] = React.useState(0);
  const data = new GetLoanInfoResponse();
  const jsonFile = useSelector((state: any) => state.style);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const tabs = [
    {
      id: 0,
      key: "UserIdentication",
      title: "احراز هویت ویدیویی",
      icon: <VideocamOutlinedIcon sx={{ fontSize: "25px" }} />,
      child: <VideoAuthorization data={props.panelTabs.kycInfo} />,
    },
    {
      id: 1,
      key: "Identity",
      title: " مدارک هویتی خریدار",
      icon: <AssignmentIndOutlinedIcon />,
      child: <IdentityInfo data={props.panelTabs.identityDocuments} />,
    },
    {
      id: 2,
      key: "Residential",
      title: " مدارک سکونتی خریدار ",
      icon: <HomeOutlinedIcon />,
      child: <PlaceInfo data={props.panelTabs.address} />,
    },
    {
      id: 3,
      key: "Incomes",
      title: " مدارک درآمدی خریدار ",
      icon: <BusinessCenterOutlinedIcon />,
      child: <IncomeInfo data={props.panelTabs.incomes} />,
    },
    {
      id: 4,
      key: "Guarantee",
      title: " اطلاعات ضمانتی خریدار",
      icon: <img src="images/warranty.svg" />,
      child: <GuarantorInfo data={props.panelTabs.guarenteeCheque} />,
    },
    {
      id: 5,
      key: "Cheque",
      title: " اقساط چک",
      icon: <img src="images/calendar.svg" />,
      child: <InstallmentInfo data={props.panelTabs.installmentCheques} />,
    },
    {
      id: 6,
      key: "Installment",
      title: "  اقساط",
      icon: <img src="images/calendar.svg" />,
      child: <Installments data={props.panelTabs.installments} />,
    },
    {
      id: 15,
      key: "BankInfos",
      title: "اطلاعات بانکی",
      icon: <AccountBalanceIcon sx={{ fontSize: "25px" }} />,
      child: (
        <BankInfo
          data={props.panelTabs.bankInfos}
          setReload={props.setReload}
        />
      ),
    },
    {
      id: 6,
      key: "Contract",
      title: " قرارداد ",
      icon: <img src="images/contract.svg" />,
      child: <ContractInfo data={props.panelTabs.contract} />,
    },
    {
      id: 7,
      key: "Factor",
      title: "  فاکتور  ",
      icon: <ReceiptLongOutlinedIcon />,
      child: <FactorInfo data={props.panelTabs.factor} />,
    },
    {
      id: 8,
      key: "AdditionalInformation",
      title: " اطلاعات تکمیلی",
      icon: <img src="images/otherTabs.svg" alt="others" />,
      child: (
        <FurtherInfo
          otherDocuments={props.panelTabs?.otherDocuments}
          additionalFieldsInfo={props.panelTabs?.additionalFieldsInfo}
        />
      ),
    },
    {
      id: 9,
      key: "CartableHistory",
      title: "گردش کار",
      icon: <HistoryIcon />,
      child: <WorkflowInfo data={props.panelTabs.cartableHistory} />,
    },
    {
      id: 10,
      key: "LoanCancellationBySupplier",
      title: " علل لغو درخواست",
      icon: <CancelOutlinedIcon />,
      child: (
        <CancellationReasons
          data={props.panelTabs.supplierCancellationReasons}
        />
      ),
    },
    {
      id: 11,
      key: "Vehicle",
      title: "مدارک خودرو",
      icon: <DirectionsCarFilledOutlinedIcon />,
      child: (
        <VehicleDocuments data={props.panelTabs.vehicle} showDocuments={true} />
      ),
    },
    {
      id: 12,
      key: "VehicleExpert",
      title: "کارشناسی خودرو",
      icon: <img src="images/manageAccounts.svg" />,
      child: <VehicleExpert data={props.panelTabs.vehicleExpert} />,
    },
    {
      id: 13,
      key: "Seller",
      title: "مدارک فروشنده",
      icon: <img src="images/SellerDoc.svg" />,
      child: <SellerDocument data={props.panelTabs.seller} />,
    },
    {
      id: 14,
      key: "Guarantor",
      title: "مدارک ضامنین",
      icon: <img src="images/guarantor.svg" />,
      child: <GuarantorDocuments data={props.panelTabs.guarantors} />,
    },
    {
      id: 15,
      key: "OtherPayment",
      title: "سایر پرداختی ها",
      icon: <WalletIcon />,
      child: <OtherPayments data={props.panelTabs.otherPayments} />,
    },
    // {
    //   id: 14,
    //   key: "Incomes",
    //   title: " اطلاعات درآمدی ",
    //   icon: <BusinessCenterOutlinedIcon />,
    //   child: <IncomeInfo data={props.panelTabs.incomes} />,
    // },
  ];
  let findedActiveTabs = [] as any;
  let count = 0;
  tabs?.map((item: any) => {
    let findedItem = props.panelTabs.tabKeys?.find((z: any) => z == item.key);

    if (findedItem != undefined) {
      item.id = count;
      count++;
      findedActiveTabs.push(item);
    }
  });
  const panelTabs = tabs.filter((v) =>
    props.panelTabs.tabKeys?.includes(v.key)
  );
  return <TabPanelCmp tab={findedActiveTabs} colorTab={jsonFile?.mainColor} />;
}
